import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfileService } from '../services/profile-service';
import { IUser } from '../../constants/interface/profile';
import { filter, map, take } from 'rxjs';

export const verifiedGuard: CanActivateFn = () => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const profile = profileService.profileData.value;

  // Profile already loaded — check immediately
  if (profile) {
    if (profile.is_account_verified) {
      return true;
    }
    router.navigate(['/verify-email'], { queryParams: { email: profile.email } });
    return false;
  }

  // Profile not loaded yet (e.g. page refresh) — wait for it
  return profileService.profileData.pipe(
    filter((p): p is IUser => p !== null),
    take(1),
    map(p => {
      if (p?.is_account_verified) {
        return true;
      }
      router.navigate(['/verify-email'], { queryParams: { email: p?.email } });
      return false;
    })
  );
};
